import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93d770ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "track-number form-item-cell" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "国内快递单号"),
  /*#__PURE__*/_createElementVNode("span", { class: "title-en" }, " Tracking Number ")
], -1))
const _hoisted_3 = { class: "form-item-input" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        class: "g-input g-input__placeholder",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.logisticsCode) = $event)),
        "placeholder-class": "g-input__placeholder",
        placeholder: "填写包裹的国内快递单号",
        type: "text"
      }, null, 512), [
        [_vModelText, _ctx.form.logisticsCode]
      ])
    ])
  ]))
}